// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M 11.1 8.9 C 10.05 9.67 9.2 10.82 8.71 12.16 L 8.18 13.6 C 8.01 14.06 7.59 14.25 7.15 14.02 C 5.94 13.38 5.57 12.13 6.04 10.75 L 6.65 9 H 3.55 C 2.34 9 1.62 8.25 1.84 7.06 L 2.45 4.05 C 2.7 2.83 3.57 2.2 4.88 2.2 H 8.7 C 9.58 2.2 10.35 2.42 11.1 2.9',
  'M 11.1 8.9 H 12.75 C 13.72 8.9 14.5 8.12 14.5 7.15 V 4.55 C 14.5 3.58 13.72 2.8 12.75 2.8 H 11.1 V 8.9 Z',
];
